import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { veiculoService } from '../../services/api';
import RelatorioManutencoes from '../../components/RelatorioManutencoes';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const VeiculoManutencoes = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: veiculoData, isLoading, error } = useQuery({
    queryKey: ['veiculo', id],
    queryFn: () => veiculoService.buscar(id),
    enabled: !!id
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex">
          <div className="ml-3">
            <h3 className="text-sm font-medium text-red-800">
              Erro ao carregar veículo
            </h3>
            <div className="mt-2 text-sm text-red-700">
              {error.response?.data?.message || 'Erro interno do servidor'}
            </div>
          </div>
        </div>
      </div>
    );
  }

  const veiculo = veiculoData?.data;

  if (!veiculo) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <div className="flex">
          <div className="ml-3">
            <h3 className="text-sm font-medium text-yellow-800">
              Veículo não encontrado
            </h3>
            <div className="mt-2 text-sm text-yellow-700">
              O veículo solicitado não foi encontrado.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Cabeçalho */}
      <div className="bg-gradient-to-br from-indigo-950 via-indigo-900 to-purple-900 rounded-2xl p-6 md:p-8 text-white shadow-xl">
        <button
          onClick={() => navigate('/frota/veiculos')}
          className="flex items-center text-indigo-300 hover:text-white transition-colors mb-4"
        >
          <ArrowLeftIcon className="h-5 w-5 mr-2" />
          Voltar para Veículos
        </button>
        
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <p className="text-indigo-300 text-sm font-medium uppercase tracking-widest mb-1">Manutenções</p>
            <h1 className="text-2xl md:text-3xl font-bold tracking-tight">
              {veiculo.placa}
            </h1>
            <p className="text-indigo-200 mt-1">
              {veiculo.marca} {veiculo.modelo} - {veiculo.ano}
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <span className="bg-white/10 border border-white/20 px-3 py-1.5 rounded-full text-sm">
              {veiculo.tipo}
            </span>
            <span className="bg-white/10 border border-white/20 px-3 py-1.5 rounded-full text-sm">
              {veiculo.cor}
            </span>
            <span className="bg-white/10 border border-white/20 px-3 py-1.5 rounded-full text-sm">
              {veiculo.hodometro?.atual?.toLocaleString()} km
            </span>
          </div>
        </div>
      </div>

      {/* Relatório de Manutenções */}
      <RelatorioManutencoes 
        veiculoId={id} 
        veiculoInfo={{
          placa: veiculo.placa,
          marca: veiculo.marca,
          modelo: veiculo.modelo,
          tipo: veiculo.tipo
        }}
      />
    </div>
  );
};

export default VeiculoManutencoes;







